<template>
  <fieldset class="account__form-section">
    <legend class="account__form-section-title">
      Whitelisted IP Addresses
    </legend>
    <p class="input-group__directions">
      Whitelist up to six IP addresses. Impressions from these IPs will not be
      logged or billed against your credits.
    </p>
    <div class="input-group__wrap input-group__wrap--wide">
      <div class="input-group__field-wrap input-group__field-wrap--wide">
        <label for="name" class="input-group__label">Nickname</label>
        <input
          id="name"
          class="input-group__input input-group__input--wide"
          :class="{
            'input-group__input--error': $v.name.$invalid && $v.name.$dirty,
          }"
          @change="handleChange"
          v-model="name"
          aria-required="true"
          :aria-invalid="$v.name.$invalid && $v.name.$dirty"
          aria-describedby="nameError"
        />
        <Error
          :invalid="!$v.name.required && $v.name.$dirty"
          message="Please enter a nickname"
        />
      </div>
    </div>
    <div class="input-group__wrap input-group__wrap--wide">
      <div class="input-group__field-wrap input-group__field-wrap--wide">
        <label for="ipAddress" class="input-group__label">IP Address</label>
        <input
          id="ipAddress"
          class="input-group__input input-group__input--wide"
          :class="{
            'input-group__input--error':
              $v.ipAddress.$invalid && $v.ipAddress.$dirty,
          }"
          @developerIps="developerIps"
          @change="handleChange"
          v-model="ipAddress"
          aria-required="true"
          :aria-invalid="$v.ipAddress.$invalid && $v.ipAddress.$dirty"
          aria-describedby="ipAddressError"
        />
        <Error
          :invalid="!$v.ipAddress.required && $v.ipAddress.$dirty"
          message="Please enter an IP address"
        />
        <Error
          :invalid="!$v.ipAddress.ipAddress && $v.ipAddress.$dirty"
          message="Please enter a valid IP address"
        />
        <Error
          :invalid="!$v.developerIps.maxLength && $v.developerIps.$dirty"
          message="A maximum of 6 addresses are allowed. You must remove one before you can add another."
        />
      </div>
      <LoadingButton
        label="Add"
        loadingLabel="Adding..."
        doneLoadingLabel="Added!"
        :event="addIgnoredIP"
        :loading="$wait.is('adding ip address')"
        :doneLoading="saved"
      />
    </div>
    <p
      class="layout--margin-top-md layout--flex-space-between layout--flex-wrap"
    >
      <strong>Hint: Your current IP Address is:</strong> {{ currentIP }}
      <LoadingButton
        small
        class="account__add-ip"
        label="Add"
        loadingLabel="Adding..."
        doneLoadingLabel="Added!"
        :event="addUserIP"
        :loading="$wait.is('adding current ip')"
        :doneLoading="savedCurrentIP"
      />
    </p>
    <transition-group
      name="list-complete"
      tag="ul"
      class="account__ip-address-list"
    >
      <ipAddressListItem
        class="list-complete-item"
        v-for="ignoredIP in developerIps"
        :key="ignoredIP.id"
        :ignoredIP="ignoredIP"
      />
    </transition-group>
  </fieldset>
</template>

<script>
import { required, ipAddress, maxLength } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import { mapWaitingActions } from "vue-wait";

import ipAddressListItem from "./ipAddressListItem";
import Error from "../../../components/Error";
import LoadingButton from "../../../components/LoadingButton";

let currentId = 1;

const formSection = "Ignored IP Addresses";

export default {
  name: "IgnoredIPAddresses",
  components: {
    ipAddressListItem,
    Error,
    LoadingButton,
  },
  data() {
    return {
      formSection,
      name: "",
      ipAddress: "",
      saved: false,
      savedCurrentIP: false,
    };
  },
  computed: {
    ...mapGetters("forms", ["formSectionChanged"]),
    ...mapGetters("account", ["currentIP", "developerIps"]),
  },
  methods: {
    ...mapActions("account", ["addIPAddress"]),
    addIgnoredIP: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$wait.start("adding ip address");
        this.saved = false;
        const newIgnoredIP = {
          name: this.name,
          ipAddress: this.ipAddress,
          id: currentId++,
        };
        this.addIPAddress(newIgnoredIP).then(() => {
          this.saved = true;
          this.$wait.end("adding ip address");
        });
      }
    },
    addUserIP: function() {
      const newIgnoredIP = {
        name: "My IP",
        ipAddress: this.currentIP,
        id: currentId++,
      };
      this.savedCurrentIP = false;
      this.$wait.start("adding current ip");
      this.addIPAddress(newIgnoredIP).then(() => {
        this.savedCurrentIP = true;
        this.$wait.end("adding current ip");
      });
    },
    handleChange: function() {
      this.saved = false;
    },
  },
  validations: {
    name: { required },
    ipAddress: { required, ipAddress },
    developerIps: { maxLength: maxLength(5) },
  },
};
</script>

<style></style>
